import React, { useEffect, useState, useContext } from "react";
import NumericInput from "react-numeric-input";
import { Link, Redirect } from "react-router-dom";
import { AuthContext } from "../../../../../context/AuthProvider";
import { EventsContext } from "../../../../../context/EventsProvider";
import moment from "moment-timezone";
import AlertDiv from "../../../../features/alert-div";
import {
  quantityInputs,
  isIEBrowser,
  isEdgeBrowser,
} from "../../../../../utils";
import ReactPixel from "react-facebook-pixel";
import Modal from "../../../../common/Modal/";
import { getCheckoutData, getDefaultGateway } from "../../../../../services/CheckoutService";
import ModalLogin from "react-modal";
import "./styles.css";
import LoginPage from "../../../../common/login";

import { withRouter } from 'react-router-dom';
import ReactGA from 'react-ga4';
import {InitializeGoogleAnalytics, TrackGoogleAnalyticsEvent} from "../../../../../utils/google-analytics/index";
import { SeatsioSeatingChart } from '@seatsio/seatsio-react/build/index.js';
import { SeatsioClient, Region } from "seatsio";
import { listSectorsByEvent } from "../../../../../services/SectorService";
import CommonModal from "../../../../features/modal/common";
import { primary_color } from "../../../../../utils/themes/colors";
import { MdIosShare, MdOutlineSms, MdOutlineContentCopy } from 'react-icons/md';
import { FacebookMessengerShareButton } from 'react-share';
import { FacebookMessengerIcon, WhatsappIcon } from 'react-share';
import { IoInformationCircleOutline } from "react-icons/io5";
import { useTranslation } from "react-i18next";

let client = new SeatsioClient(Region.SA(), "c122cf35-2dde-47db-8454-867d06980060")

function ProductDetailOne(props) {
  const { t } = useTranslation();
  const { event, prevOrder } = props;
  console.log("event", props);
  const payment_gateway = event && event.organizer && event.organizer.gateway && event.organizer.gateway.length > 0 ? event.organizer.gateway[0].payment_gateway.toLowerCase() : null;
  console.log("payment_gateway", payment_gateway);
  const [error, setError] = useState(false);
  const [order, setOrder] = useState();
  const [showTicketDetail, setShowTicketDetail] = useState(false);
  const [showIntallment, setShowIntallment] = useState(false);
  const { loggedIn, loginWithToken } = useContext(AuthContext);
  const { setCheckoutData } = useContext(EventsContext);
  const [modalIsOpen, setModalIsOpen] = useState(false);
  const [loginOrCreate, setLoginOrCreate] = useState();
  const [teste, setTeste] = useState(false);
  const [defaultGateway, setDefaultGateway] = useState();
  const [dltRefer, setDltRefer] = useState(null);
  const customStyles = {
    content: {
      top: "50%",
      left: "50%",
      right: "auto",
      bottom: "auto",
      transform: "translate(-50%, -50%)",
      borderRadius: "20px",
    },
  };
  const [selectedSeats, setSelectedSeats] = useState([]);
  const [selectedSectors, setselectedSectors] = useState([]);
  const [sectors, setSectors] = useState();
  const [selectSectorModal, setSelectSectorModal] = useState(false);
  const [shareModal, setShareModal] = useState(false);

  useEffect(() => {
    const urlParams = new URLSearchParams(window.location.search);
    const dlt = urlParams.get("dlt");
    if (dlt) setDltRefer(dlt);
  }, []);

  const incrementValue = (fieldName, ticket) => {
    sectors.forEach((sector) => {
      if (ticket.sector_id === sector.id)
        setselectedSectors(prevSelectedSectors => [...prevSelectedSectors, sector])
    })
    TrackGoogleAnalyticsEvent('Checkout', 'Custom Click', 'Plus Button');
    setError(false);
    const input = document.getElementById(fieldName);
    if (input) {
      const currentVal = parseInt(input.value, 10);
      if (!isNaN(currentVal) && currentVal < ticket.max_sale_qty) {
        input.value = currentVal + 1;
      } else {
        input.value = currentVal;
      }
    }
  };

  const decrementValue = (fieldName, ticket) => {
    sectors.map((sector) => {
      if (sector.id === ticket.sector_id) {
        setSelectedSeats((prevSelectedSeats) => {
          const lastSeatSectorIndex = prevSelectedSeats.slice().reverse().findIndex((selectedSeat) => selectedSeat.labelSector === sector.name);
          if (lastSeatSectorIndex !== -1) {
            const updatedSeats = [...prevSelectedSeats];
            updatedSeats.splice(updatedSeats.length - 1 - lastSeatSectorIndex, 1);
            return updatedSeats;
          }
    
          return prevSelectedSeats;
        });
      }
    });
    setselectedSectors(prevSelectedSectors => {
      const indexToRemove = prevSelectedSectors.findIndex(selectedSector => selectedSector.id === ticket.sector_id);
      if (indexToRemove !== -1) {
        const updatedSectors = [...prevSelectedSectors];
        updatedSectors.splice(indexToRemove, 1);
        return updatedSectors;
      }
      return prevSelectedSectors;
    });
    TrackGoogleAnalyticsEvent('Checkout', 'Custom Click', 'Minus Button');
    setError(false);
    const input = document.getElementById(fieldName);
    if (input) {
      const currentVal = parseInt(input.value, 10);
      if (!isNaN(currentVal) && currentVal > 0) {
        input.value = currentVal - 1;
      } else {
        input.value = 0;
      }
    }
  };

    useEffect(() => {
      const handleLoginWithToken = async () => {
        const urlParams = new URLSearchParams(window.location.search);
        const token = urlParams.get('exchange_token');

        if (token) {
          try {
            await loginWithToken(token);
            const newUrl = window.location.pathname + window.location.hash;
            window.history.replaceState({}, document.title, newUrl);
          } catch (error) {
            console.error('Error during login with token:', error);
          }
        }
      };

      handleLoginWithToken();
    })

  useEffect(() => {
    quantityInputs();

    const fetchSectors = async () => {
      if (event && event.id) {
        const sectorsData = await listSectorsByEvent(event.id)
        setSectors(
          sectorsData.data.sort(
            (a, b) => a.presentation_order - b.presentation_order
          )
        )
      }
    }
    if (event && event.pixel_id) {
      ReactPixel.init(event.pixel_id);
      ReactPixel.trackSingle(event.pixel_id, "PageView");
    }

    fetchSectors();
  }, [event]);

  useEffect(() => {
    const fetchDefaultGatewayGroovoo = async () => {
      try {
        console.log("Fetching default gateway");
        const response = await getDefaultGateway();
        console.log("Default gateway", response.data);
        if (response.data && response.data.default_gateway) {
          setDefaultGateway(response.data.default_gateway.payment_gateway.toLowerCase());
        }
      } catch (error) {
        console.error("Error fetching default gateway", error);
      }
    };
    if(!payment_gateway)
      fetchDefaultGatewayGroovoo();

  }, []);



  const handleObjectSelected = (object) => {
    if (object) {
      console.log(`OBJETO SELECIONADO NO MAP DO SEATS.IO`)
      console.dir(object)
      sectors.forEach((sector) => {
        if (object.category.key === sector.key_seatsio) {
          event.tickets.forEach((ticket) => {
            if (ticket.status === 1 && ticket.sector_id === sector.id) {
              setSelectedSeats(prevSelectedSeats => [...prevSelectedSeats, {labelSector: object.category.label, seatId: object.seatId, ticket_id: ticket.id}]);
              incrementValue(ticket.id + "-qty", ticket)
            }
          })
        }
      })
    }
  };

  const handleObjectDeselected = (object) => {
    if (object) {
      console.log(`OBJETO DESELECIONADO NO MAP DO SEATS.IO`)
      console.dir(object)
      sectors.forEach((sector) => {
        if (object.category.key === sector.key_seatsio) {
          event.tickets.forEach((ticket) => {
            if (ticket.sector_id === sector.id) {
              decrementValue(ticket.id + "-qty", ticket)
            }
          })
        }
      })
    }
  };

  // useEffect(() => {
  //   console.log(`SELECTED SEATS ===== ${JSON.stringify(selectedSeats)}`)
  //   console.log(`SELECTED SECTORS ===== ${JSON.stringify(selectedSectors)}`)
  // }, [selectedSeats, selectedSectors])

  // useEffect(() => {
   
  //     // Moved the props.listen inside useEffect
  //     props.listen((location, action) => {
  //       ReactGA.set({ page: location.pathname });
  //       ReactGA.pageview(location.pathname);
  //     });
  //   }, [props]);

  const getOrder = async () => {
    try {
      TrackGoogleAnalyticsEvent('Checkout', 'Custom Click', 'Place Order');
      const auxTickets = [];

      /**
       * should accept only if all tickets
       * accept installments or if all tickets do not accept installments
       * mixing ticket types in one order should not be allowed
       */
      let accept_installments_arr = [];
      event.tickets.forEach((ticket) => {
        const el = document.getElementById(ticket.id + "-qty");

        if (el) {
          const qty = el.value;
          // console.log("el", el  );
          // console.log("qty", qty);
          if (qty > 0) {
            auxTickets.push({
              id: ticket.id,
              name: ticket.description, // For Facebook Pixel
              qty: qty,
              has_surcharge_fee: ticket.has_surcharge_fee,
            });
            accept_installments_arr.push(ticket.accept_installments);
          }
        }
      });
      console.log("accept_installments_arr", accept_installments_arr);
      if (auxTickets.length === 0)
        throw Error("Please select at least one ticket.");
      //does order contain mixed ticket types (installments)
      if (new Set(accept_installments_arr).size !== 1)
        throw Error(
          "Please select tickets of same type. Either tickets that accept installments or tickets that do not."
        );

      //if order contains installments
      const has_installments =
        accept_installments_arr.reduce((a, b) => a + b, 0) > 0;
      const orderData = {
        event_id: event.id,
        tickets: auxTickets,
      };

      if (event.pixel_id)
        ReactPixel.trackSingleCustom(
          event.pixel_id,
          "StartCheckout",
          orderData
        );

      const checkoutData = (await getCheckoutData(orderData)).data;
      console.log("checkoutData", checkoutData);
      checkoutData.has_installments = has_installments;
      setOrder(checkoutData);
      setCheckoutData({ event: event, order: checkoutData, seats: selectedSeats, sectors: selectedSectors });
      setModalIsOpen(true);
    } catch (err) {
      const error_message = err.response
        ? err.response.data.message
        : err.message;
      setError(error_message);
    }
  };

  const quantityIfIsAvailable = (ticket) => {
    if (ticket.status === 2) {
      return (
        <p>Sale will start on {moment(ticket.starts_at).format("MM/DD")}</p>
      );
    } else if (
      Number(event.status) !== 1 ||
      Number(ticket.status) === 3 ||
      Number(ticket.qty_available) === 0
    ) {
      return <p>Sold out</p>;
    } else {
      return (
        <div
          className="product-details-quantity"
          style={{
            display: "flex",
            justifyContent: "center",
            marginRight: "10px",
          }}
        >
          {prevOrder && prevOrder.length > 0 ? (
            <div className="input-group input-qty-ticket" style={{ display: "flex", alignItems: "center" }}>
              <input
                type="button"
                value="-"
                className="button-minus"
                onClick={() => decrementValue(ticket.id + "-qty", ticket)}
              />
              <input
                type="text"
                step="1"
                max={ticket.max_sale_qty}
                required
                defaultValue={
                  prevOrder.find((item) => item.id === ticket.id)
                    ? prevOrder.find((item) => item.id === ticket.id).qty
                    : 0
                }
                min="0"
                name="quantity"
                id={ticket.id + "-qty"}
                className="quantity-field"
                readOnly
                style={{ maxWidth: "50px", textAlign: "center" }}
              />
              <input
                type="button"
                value="+"
                className="button-plus"
                onClick={() => incrementValue(ticket.id + "-qty", ticket)}
              />
            </div>
          ) : (
            <div className="input-group" style={{ display: "flex", alignItems: "center", flexWrap: "nowrap" }}>
              <button
                type="button"
                background-color="green"
                value="-"
                className="button-minus"
                onClick={() => decrementValue(ticket.id + "-qty", ticket)}
              ><span>-</span></button>
              <input
                type="text"
                step="1"
                max={ticket.max_sale_qty}
                defaultValue="0"
                min="0"
                required
                name="quantity"
                id={ticket.id + "-qty"}
                className="quantity-field"
                readOnly
              />
              <button
                type="button"
                value="+"
                className="button-plus"
                onClick={() => (event.requires_reserved && event.key_event_chart !== null) ? setSelectSectorModal(true) : incrementValue(ticket.id + "-qty", ticket)}
              ><span>+</span></button>
            </div>
          )}
        </div>
      );
    }
  };

  const closeModal = () => {
    setModalIsOpen(false);
    setLoginOrCreate(null);
  };

  const copyToClipboard = () => {
    const textField = document.createElement('textarea');
    textField.innerText = window.location.href;
    document.body.appendChild(textField);
  
    textField.select();
    textField.setSelectionRange(0, 99999); 

    document.execCommand('copy');
  
    textField.remove();
  
    alert('Link copiado para a área de transferência!');
  };

  // const shareOnFacebookChat = () => {
  //   const message = encodeURIComponent(`Look at the event ${event.name}. Link: ${window.location.href}`);
  //   window.open(`https://www.facebook.com/dialog/send?app_id=${YOUR_APP_ID}&link=${window.location.href}&redirect_uri=${window.location.href}&display=popup&quote=${message}`, '_blank');
  // };

  const shareOnWhatsApp = () => {
    const message = encodeURIComponent(`Look at the event ${event.name}. Link: ${window.location.href}`);
    window.open(`https://api.whatsapp.com/send?text=${message}`, '_blank');
  };

  const shareOnSMS = () => {
    const message = `Look at the event ${event.name}. Link: ${window.location.href}`;
    const url = `sms:?body=${encodeURIComponent(message)}`;
    window.open(url);
  };

  // const shareOnInstagram = () => {
  //   const message = encodeURIComponent(`Look at the event ${event.name}. Link: ${window.location.href}`);
  //   window.open(`https://www.instagram.com/direct/new/?text=${message}`, '_blank');
  // };

  return (
    <div className={"product-details"}>
      <div style={{ display: 'flex', flexDirection: 'row', justifyContent: 'space-between' }}>
        <h1 className="product-title">{event.name}</h1>
        <button
          className="btn-primary"
          style= {{ display: 'inline-flex', justifyContent: 'space-evenly', fontSize: '1.5rem', border: '1px solid', minWidth: '100px', height: '40px' , borderRadius: '20px', alignItems: 'center' }}
          onClick={() => setShareModal(true)}
        >
          <MdIosShare style={{fontSize: 'medium'}} />
          <span>{t('ProductDetailOne.share')}</span>
        </button>
      </div>

      <div>
        <CommonModal
          isOpen={shareModal}
          onClose={() => {setShareModal(false);}}
        >
          <h4 className="text-center" style={{margin: '30px', marginTop: '20px', marginBottom: '40px'}}> {t('ProductDetailOne.shareThisEventWithYourFriends')}</h4>

          <div style={{ display: 'flex', flexDirection: 'row', margin: '15px', justifyContent: 'space-evenly'}}>
            <FacebookMessengerShareButton 
              url={window.location.href}
            >
              <FacebookMessengerIcon size={32} round={true} />
              <span style={{ fontSize: '16px' }}> {t('ProductDetailOne.facebookChat')} </span>
            </FacebookMessengerShareButton>

            <div onClick={shareOnWhatsApp} style={{cursor: 'pointer'}}>
              <WhatsappIcon size={32} round={true} />
              <span style={{ fontSize: '16px' }}> {t('ProductDetailOne.whatsapp')} </span>
            </div>
          </div>

          <div style={{ display: 'flex', flexDirection: 'row', margin: '15px', justifyContent: 'space-evenly'}}>
            <div onClick={shareOnSMS} style={{cursor: 'pointer'}}>
              <button style={{ width: 32, height: 32, borderRadius: 50, backgroundColor: '#18bf34', alignItems: 'center'}}>
                <MdOutlineSms style={{fontSize: 'large', color: 'white'}} />
              </button>
              <span style={{ fontSize: '16px', marginLeft: '5px' }}> {t('ProductDetailOne.sms')} </span>
            </div>

            {/* <div onClick={shareOnInstagram}>
              <button style={{ width: 32, height: 32, borderRadius: 50, backgroundColor: '#d8005a'}} >
                <IoLogoInstagram style={{fontSize: 'large', color: 'white'}} />
              </button>
              <span> Instagram </span>
            </div> */}
          </div>

          <div 
            style={{ 
              alignSelf: 'center', display: 'inline-flex', 
              justifyContent: 'space-around', fontSize: '1.4rem', 
              border: '1px solid', borderColor: primary_color, 
              width: '100%', minHeight: '40px' , 
              borderRadius: '20px', alignItems: 'center',
              marginTop: 20, marginBottom: 20
            }}
          >
            <span style={{ overflow: "hidden", textOverflow: "ellipsis", marginLeft: 5 }}> {window.location.href} </span>
            <button onClick={copyToClipboard}>
              <MdOutlineContentCopy style={{ fontSize: 'medium', color: primary_color }} />
            </button>
          </div>
        </CommonModal>
      </div>
  
      <div className="product-content">
        <p
          dangerouslySetInnerHTML={{
            __html: event.detail,
          }}
        ></p>
      </div>

      <div className="row" style={{ marginBottom: "40px" }}>
        <div className="col-sm-6 col-lg-6">
          <div className="icon-box icon-box-side">
            <span className="icon-box-icon text-dark">
              <i className="icon-app-store"></i>
            </span>
            <div className="icon-box-content">
              <h3 className="icon-box-title">
                <a href="https://apps.apple.com/us/app/groovoo-social-networking/id1529056214">
                 {t('ProductDetailOne.downloadIOS')}
                </a>
              </h3>
              <p>{t("ProductDetailOne.startTheWarmUp")}</p>
            </div>
          </div>
        </div>
        <div className="col-sm-6 col-lg-6">
          <div className="icon-box icon-box-side">
            <span className="icon-box-icon text-dark">
              <i className="icon-google-play"></i>
            </span>
            <div className="icon-box-content">
              <h3 className="icon-box-title">
                <a href="https://play.google.com/store/apps/details?id=com.groovoo&amp;hl=pt_BR&amp;gl=US">
                {t('ProductDetailOne.downloadAndroid')}
                </a>
              </h3>
              <p>{t("ProductDetailOne.startTheWarmUp")}</p>
            </div>
          </div>
        </div>
      </div>
      {event.is_ticketable !== 0 &&
        event.tickets &&
        event.tickets.length > 0 && (
          <>
            
            <div className="product-details" style={{border: "0.5px solid #cccccc", borderRadius: "10px", textAlign: "center"}}>
              {sectors && sectors.map((sector, sectorIndex) => {
                const sectorTickets = event.tickets
                  .filter(ticket => {
                    const base = ticket.sector_id === sector.id && ticket.status !== 0;

                    if (dltRefer)
                      return base && ticket.dlt_refer === dltRefer;
                    if (ticket.exclusive_dlsale)
                      return false;

                    return base;
                  })
                  .sort((a, b) => a.presentation_order - b.presentation_order);

                if (sectorTickets && sectorTickets.length > 0) {
                  return (
                    <div key={sectorIndex} style={{alignItems: "center"}} >
                      <div className="sector-name-container" style={{ maxWidth: "100%", alignItems: "center", marginBottom: "-10px" }}>
                        <span style={{ fontSize: "2rem", fontWeight: "bolder", color: "black"}}>{sector.name}</span>
                      </div>
                      <div className="sector-tickets-container" style={{ margin: "30px", justifyContent: "space-between" }}>
                        {sectorTickets.map((ticket, index) => (
                          <div className="ticket-container" key={index} style={{ display: "flex", flexDirection: "column", alignItems: "center", marginBottom: "20px" }}>
                            <div className="ticket-details" style={{ display: "flex", flexDirection: "row", marginBottom: "-5px" }}>
                              <label style={{ fontWeight: "normal", fontSize: "1.6rem", width: "100%"}}>{ticket.description}</label>
                              {ticket.text_detail &&
                                <div style={{ cursor: 'pointer' }}>
                                  <IoInformationCircleOutline 
                                      size={20} 
                                      round={true} 
                                      onClick={() => setShowTicketDetail(ticket)} 
                                      style={{ color: primary_color, marginLeft: '5px' }}
                                  />
                                </div>
                              }
                            </div>
                            <div className="ticket-price-quantity" style={{ display: "flex", flexDirection: "row" }}>
                              {ticket.is_paid ? (
                                <div style={{ color: primary_color, fontSize: "1.8rem" }}>${Number(ticket.price)}</div>
                              ) : (
                                <div style={{ color: "#5eaf5e", fontSize: "1.8rem" }}>FREE</div>
                              )}
                              {ticket.accept_installments > 0 &&
                                <div style={{ cursor: 'pointer' }}>
                                  <IoInformationCircleOutline 
                                      size={20} 
                                      round={true} 
                                      onClick={() => setShowIntallment(ticket)} 
                                      style={{ color: primary_color, marginLeft: '5px' }}
                                  />
                                </div>
                              }
                              <div style={{ marginLeft: "1vw" }}>
                                {quantityIfIsAvailable(ticket)}
                              </div>
                            </div>
                          </div>
                        ))}
                      </div>
                      <div className="sector-separator" style={{ width: "50%", margin: "auto", borderTop: "1px solid #cccccc", marginBottom: "30px" }}></div>
                    </div>
                  );
                } else {
                  return null;
                }
              })}
            </div>

            {/* <div className="details-filter-row details-row-size">
              <div className="col-2">
                <label>Color</label>
              </div>
              <div className="col-3">
                <label>Ticket</label>
              </div>
              <div className="col-3">
                <label>Price</label>
              </div>
              <div className="col-3">
                <label>Qty</label>
              </div>
            </div>
            {event.tickets
              .filter((t) => t.status !== 0)
              .sort((a, b) => a.presentation_order - b.presentation_order)
              .map((ticket, index) => (
                <div
                  className="details-filter-row details-row-size"
                  key={index}
                >
                  <div className="col-2">
                    <div
                      style={{
                          width: '30px', height: '30px',
                          backgroundColor: ticket.color, marginLeft: '10px',
                          borderBlockColor: 'black', borderStyle: 'solid',
                          borderWidth: '1px', borderRadius: '50px',
                          cursor: 'pointer'
                      }}>

                    </div>
                  </div>
                  <div className="col-3">
                    <label
                      style={{
                        fontWeight: "normal",
                        fontSize: "1.6rem",
                        width: "100%",
                      }}
                    >
                      {ticket.description}
                    </label>
                    {ticket.text_detail && (
                      <button
                        onClick={() => setShowTicketDetail(ticket)}
                        className="btn-modalDetail"
                      >
                        Detail
                      </button>
                    )}
                  </div>
                  <div className="col-3">
                    {ticket.is_paid ? (
                      <div style={{ color: primary_color, fontSize: "1.8rem" }}>
                        ${Number(ticket.price)}
                      </div>
                    ) : (
                      <label style={{ color: "#5eaf5e", fontSize: "1.8rem" }}>
                        FREE
                      </label>
                    )}
                    {ticket.accept_installments > 0 && (
                      <span class="badge badge-secondary">installments</span>
                    )}
                  </div>
                  <div className="col-3">{quantityIfIsAvailable(ticket)}</div>
                </div>
              ))} */}
            {error && <AlertDiv error message={error} title="Purchase error" />}

            <div className="product-details-action">
              <button
                className="btn-product btn-cart"
                onClick={() => getOrder()}
              >
                {/* <span>Place Order</span> */}
                <span>{t('ProductDetailOne.placeOrder')}</span>
              </button>

              <label style={{ marginTop: "10px" }}>
                {" "}
                {/* Placing an order you agree with our */}
                {t('ProductDetailOne.placingAnOrderYouAgreeWithOur')}
                <a
                  href={process.env.PUBLIC_URL + "/terms.html"}
                  target="_blank"
                  rel="noreferrer"
                >
                  {" "}
                  {/* Terms of Use */}
                  {t('ProductDetailOne.termsOfUse')}
                </a>{" "}
                {/* and */}
                {t('ProductDetailOne.and')}
                <a
                  href={process.env.PUBLIC_URL + "/privacy.html"}
                  target="_blank"
                  rel="noreferrer"
                >
                  {" "}
                  {/* Privacy Policy */}
                  {t('ProductDetailOne.privacyPolicy')}
                </a>{" "}
              </label>
              {
                order && loggedIn && (payment_gateway || defaultGateway) ? (
                  <div>
                    <Redirect
                      to={{
                        pathname:
                          Number(order.total_price) === 0
                            ? `/shop/free-checkout`
                            : `/shop/checkout-${payment_gateway ? payment_gateway : defaultGateway}`,
                          state: {
                          event: event,
                          order: order,
                          seats: selectedSeats,
                          sectors: selectedSectors,
                        },
                      }}
                    />
                  </div>
                ) : (
                  order &&
                  !loggedIn && (
                    <div>
                      <ModalLogin
                        isOpen={modalIsOpen}
                        // onAfterOpen={afterOpenModal}
                        onRequestClose={closeModal}
                        style={customStyles}
                        contentLabel="Modal"
                      >
                        {!loginOrCreate ? (
                          <div className="modalLogin">
                            <span className="title">
                              {/* To continue, sign in or create an account */}
                              {t('ProductDetailOne.toContinueSignInOrCreateAnAccount')}
                            </span>
                            <button
                              className="toLogin"
                              onClick={() => {
                                setLoginOrCreate(1);
                              }}
                            >
                              {/* Login */}
                              {t('ProductDetailOne.login')}
                            </button>
                            <button
                              className="toCreateAccount"
                              onClick={() => {
                                setLoginOrCreate(2);
                              }}
                            >
                              {/* Create Account */}
                              {t('ProductDetailOne.createAccount')}
                            </button>
                          </div>
                        ) : (
                          <LoginPage
                            loginOrCreate={loginOrCreate}
                            event={event}
                            order={order}
                          ></LoginPage>
                        )}
                      </ModalLogin>
                    </div>
                  )
                )
                // <div>
                //     <div>{orderDetail(order, event)}</div>
                //     {<div><Redirect to={{
                //         pathname: (Number(order.total_price) === 0) ? `/shop/free-checkout` : `/shop/checkout`,
                //         state:
                //         {
                //             event: event,
                //             order: order
                //         }
                //     }} />

                //     </div>}
                // </div>
              }
            </div>
          </>
        )}

      {event.is_ticketable == 0 && event.external_shop_url && (
        <div className="product-details-action">
          {isIEBrowser() || isEdgeBrowser() ? (
            <button
              className="btn-product btn-cart"
              style={{ minHeight: "4rem" }}
              onClick={() => window.open(event.external_shop_url, "_blank")}
            >
              {/* <span>BUY TICKETS</span> */}
              <span>{t('ProductDetailOne.buyTickets')}</span>
            </button>
          ) : (
            <button
              className="btn-product btn-cart"
              onClick={() => window.open(event.external_shop_url, "_blank")}
            >
              {/* <span>BUY TICKETS</span> */}
              <span>{t('ProductDetailOne.buyTickets')}</span>
            </button>
          )}
        </div>
      )}

      {(event.images.length > 2 || event.requires_reserved) && (
        <div style={{ margin: "20px 0px" }}>
          <div
            style={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              paddingTop: "5px",
            }}
          >
            {/* <p style={{ fontSize: "18px", fontWeight: "500" }}>EVENT MAP</p> */}
            <p style={{ fontSize: "18px", fontWeight: "500" }}>{t('ProductDetailOne.eventMap')}</p>
          </div>
          <div
            style={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              padding: "5px 0px 30px 0px",
            }}
          >
            {event.requires_reserved && event.key_event_chart !== null ? 
              <SeatsioSeatingChart
                workspaceKey="6cfec988-afd6-461a-ae5f-285ca9aabd94"
                event = {event.key_event_chart}
                chartJsUrl="https://cdn-{region}.seatsio.net/chart.js"
                region="sa"
                mode="static" 
                onObjectClicked={() => {setSelectSectorModal(true)}}
                selectedObjects={selectedSeats.length > 0 ? selectedSeats.map(seat => ({ label: seat.seatId })) : []}
              />
            : 
              <img
                src={event.images[2].url_image}
                alt="mapa de assentos"
                width={
                  event.images[2].url_image.includes("feed") ? "100%" : "70%"
                }
                style={{ border: "3px solid #c4c4c4" }}
              /> 
            }
          </div>
        </div>
      )}

      <CommonModal isOpen={selectSectorModal} onClose={() => {setSelectSectorModal(false);}}>
        <div style={{ minWidth: "50vw", maxHeight: "70vh", overflowY: "auto" }}>
          <div
            style={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              paddingTop: "5px",
            }}
          >
            {/* <p style={{ fontSize: "18px", fontWeight: "500" }}>EVENT MAP</p> */}
            <p style={{ fontSize: "18px", fontWeight: "500" }}>{t('ProductDetailOne.selectSeats')}</p>
          </div>
          <div
            style={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              padding: "5px 0px 30px 0px",
            }}
          >
            {event.requires_reserved && event.key_event_chart !== null ? 
              <SeatsioSeatingChart
                workspaceKey="6cfec988-afd6-461a-ae5f-285ca9aabd94"
                event = {event.key_event_chart}
                chartJsUrl="https://cdn-{region}.seatsio.net/chart.js"
                region="sa"
                onObjectSelected={handleObjectSelected}
                onObjectDeselected={handleObjectDeselected}
              />
            :
            <div></div>
            }
          </div>
          <div className="text-center" style={{ display: 'flex', flexDirection: 'column', alignItems: 'center',  marginTop: '30px', marginBottom: '20px' }}>
            <button type="button" onClick={() => setSelectSectorModal(false)} className="btn btn-primary" >
                {/* Done */}
                {t('ProductDetailOne.done')}
            </button>
            {/* <button onClick={() => setSelectSectorModal(false)}>
                Cancel
            </button> */}
          </div>
        </div>
      </CommonModal>

      <div className="product-details-footer">
        <div className="product-cat">
          {/* <span>Category: </span> */}
          <span>{t('ProductDetailOne.category')}</span>
          <Link to="#">{event.category.description}</Link>
        </div>
      </div>
      {showTicketDetail && (
        <CommonModal
          isOpen={showTicketDetail}
          onClose={() => {setShowTicketDetail(false)}}
        >
          <h4 className="text-center" style={{ marginBottom: '40px' }}> {showTicketDetail.description} </h4>

          <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
            <span style={{ fontSize: '16px' }}> {showTicketDetail.text_detail} </span>
          </div>
        </CommonModal>
      )}
      {showIntallment && (
        <CommonModal
          isOpen={showIntallment}
          onClose={() => {setShowIntallment(false)}}
        >
          <h4 className="text-center" style={{ marginBottom: '40px' }}> {showIntallment.description} </h4>

          <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center'  }}>
            {/* <span style={{ fontSize: '16px' }}> The value of this ticket can be paid in installments. </span> */}
            <span style={{ fontSize: '16px' }}> {t('ProductDetailOne.valueInstallments')} </span>
          </div>
        </CommonModal>
      )}
      {props.children}
      {/* {teste && <div>
        <Redirect
            to={{
              pathname: `${process.env.PUBLIC_URL}/login/activate-account`,
              state: {
                event: event,
                order: order,
                userToActivate: 3,
              },
            }}
          />
      </div>} */}
    </div>
  );
}

export default withRouter(ProductDetailOne);




// import React, { useEffect, useState, useContext } from "react";
// import NumericInput from "react-numeric-input";
// import { Link, Redirect } from "react-router-dom";
// import { AuthContext } from "../../../../../context/AuthProvider";
// import { EventsContext } from "../../../../../context/EventsProvider";
// import moment from "moment-timezone";
// import AlertDiv from "../../../../features/alert-div";
// import {
//   quantityInputs,
//   isIEBrowser,
//   isEdgeBrowser,
// } from "../../../../../utils";
// import ReactPixel from "react-facebook-pixel";
// import Modal from "../../../../common/Modal/";
// import { getCheckoutData } from "../../../../../services/CheckoutService";
// import ModalLogin from "react-modal";
// import "./styles.css";
// import LoginPage from "../../../../common/login";

// import { withRouter } from 'react-router-dom';
// import ReactGA from 'react-ga4';

// // // Google analytics
// // import ReactGA from 'react-ga';
// // const TRACKING_ID = "G-9SPHK0BV73";
// // console.log('RESULT', ReactGA.initialize(TRACKING_ID))

// function ProductDetailOne(props) {
//   const { event, prevOrder } = props;
//   const [error, setError] = useState(false);
//   const [order, setOrder] = useState();
//   const [showTicketDetail, setShowTicketDetail] = useState(false);
//   const { loggedIn } = useContext(AuthContext);
//   const { setCheckoutData } = useContext(EventsContext);
//   const [modalIsOpen, setModalIsOpen] = useState(false);
//   const [loginOrCreate, setLoginOrCreate] = useState();
//   const [teste, setTeste] = useState(false);
//   const customStyles = {
//     content: {
//       top: "50%",
//       left: "50%",
//       right: "auto",
//       bottom: "auto",
//       transform: "translate(-50%, -50%)",
//       borderRadius: "20px",
//     },
//   };


//   // const RouteChangeTracker = ({ history }) => {

//   //   history.listen((location, action) => {
//   //     ReactGA.set({ page: location.pathname });
//   //     ReactGA.pageview(location.pathname);
//   //   });

//   //   return <div></div>;
//   // };

//   const incrementValue = (fieldName, ticket) => {
//     setError(false);
//     const input = document.getElementById(fieldName);
//     if (input) {
//       const currentVal = parseInt(input.value, 10);
//       if (!isNaN(currentVal) && currentVal < ticket.max_sale_qty) {
//         input.value = currentVal + 1;
//       } else {
//         input.value = currentVal;
//       }
//     }
//   };

//   const decrementValue = (fieldName) => {
//     setError(false);
//     const input = document.getElementById(fieldName);
//     if (input) {
//       const currentVal = parseInt(input.value, 10);
//       if (!isNaN(currentVal) && currentVal > 0) {
//         input.value = currentVal - 1;
//       } else {
//         input.value = 0;
//       }
//     }
//   };

//   useEffect(() => {
//     quantityInputs();
//     // console.log(props);
//     if (event && event.pixel_id) {
//       ReactPixel.init(event.pixel_id);
//       ReactPixel.trackSingle(event.pixel_id, "PageView");
//     }
//     // ReactGA.pageview(window.location.pathname + window.location.search);
//     // console.log(`window.location.pathname ${window.location.pathname}`)
//     // console.log(`window.location.search ${window.location.search}`)
//   }, [event]);

//   // useEffect(() => {
   
//   //     // Moved the props.listen inside useEffect
//   //     props.listen((location, action) => {
//   //       ReactGA.set({ page: location.pathname });
//   //       ReactGA.pageview(location.pathname);
//   //     });
//   //   }, [props]);
  

//   // useEffect(() => {
//   //   ReactGA.pageview(window.location.pathname + window.location.search);
//   //   console.log(`window.location.pathname ${window.location.pathname}`)
//   //   console.log(`window.location.search ${window.location.search}`)
//   // }, []);

//   const getOrder = async () => {
//     try {
//       const auxTickets = [];

//       /**
//        * should accept only if all tickets
//        * accept installments or if all tickets do not accept installments
//        * mixing ticket types in one order should not be allowed
//        */
//       let accept_installments_arr = [];
//       event.tickets.forEach((ticket) => {
//         const el = document.getElementById(ticket.id + "-qty");

//         if (el) {
//           const qty = el.value;
//           // console.log("el", el  );
//           // console.log("qty", qty);
//           if (qty > 0) {
//             auxTickets.push({
//               id: ticket.id,
//               name: ticket.description, // For Facebook Pixel
//               qty: qty,
//               has_surcharge_fee: ticket.has_surcharge_fee,
//             });
//             accept_installments_arr.push(ticket.accept_installments);
//           }
//         }
//       });
//       console.log("accept_installments_arr", accept_installments_arr);
//       if (auxTickets.length === 0)
//         throw Error("Please select at least one ticket.");
//       //does order contain mixed ticket types (installments)
//       if (new Set(accept_installments_arr).size !== 1)
//         throw Error(
//           "Please select tickets of same type. Either tickets that accept installments or tickets that do not."
//         );

//       //if order contains installments
//       const has_installments =
//         accept_installments_arr.reduce((a, b) => a + b, 0) > 0;
//       const orderData = {
//         event_id: event.id,
//         tickets: auxTickets,
//       };

//       if (event.pixel_id)
//         ReactPixel.trackSingleCustom(
//           event.pixel_id,
//           "StartCheckout",
//           orderData
//         );

//       const checkoutData = (await getCheckoutData(orderData)).data;
//       console.log("checkoutData", checkoutData);
//       checkoutData.has_installments = has_installments;
//       setOrder(checkoutData);
//       setCheckoutData({ event: event, order: checkoutData });
//       setModalIsOpen(true);
//     } catch (err) {
//       const error_message = err.response
//         ? err.response.data.message
//         : err.message;
//       setError(error_message);
//     }
//   };

//   const quantityIfIsAvailable = (ticket) => {
//     if (ticket.status === 2) {
//       return (
//         <p>Sale will start on {moment(ticket.starts_at).format("MM/DD")}</p>
//       );
//     } else if (
//       Number(event.status) !== 1 ||
//       Number(ticket.status) === 3 ||
//       Number(ticket.qty_available) === 0
//     ) {
//       return <p>Sold out</p>;
//     } else {
//       return (
//         <div
//           className="product-details-quantity"
//           style={{
//             display: "flex",
//             justifyContent: "center",
//             marginRight: "10px",
//           }}
//         >
//           {prevOrder && prevOrder.length > 0 ? (
//             <div className="input-group input-qty-ticket" style={{ display: "flex", alignItems: "center" }}>
//               <input
//                 type="button"
//                 value="-"
//                 className="button-minus"
//                 onClick={() => decrementValue(ticket.id + "-qty", ticket)}
//               />
//               <input
//                 type="text"
//                 step="1"
//                 max={ticket.max_sale_qty}
//                 required
//                 defaultValue={
//                   prevOrder.find((item) => item.id === ticket.id)
//                     ? prevOrder.find((item) => item.id === ticket.id).qty
//                     : 0
//                 }
//                 min="0"
//                 name="quantity"
//                 id={ticket.id + "-qty"}
//                 className="quantity-field"
//                 readOnly
//                 style={{ maxWidth: "50px", textAlign: "center" }}
//               />
//               <input
//                 type="button"
//                 value="+"
//                 className="button-plus"
//                 onClick={() => incrementValue(ticket.id + "-qty", ticket)}
//               />
//             </div>
//           ) : (
//             <div className="input-group" style={{ display: "flex", alignItems: "center", flexWrap: "nowrap" }}>
//               <button
//                 type="button"
//                 background-color="green"
//                 value="-"
//                 className="button-minus"
//                 onClick={() => decrementValue(ticket.id + "-qty", ticket)}
//               ><span>-</span></button>
//               <input
//                 type="text"
//                 step="1"
//                 max={ticket.max_sale_qty}
//                 defaultValue="0"
//                 min="0"
//                 required
//                 name="quantity"
//                 id={ticket.id + "-qty"}
//                 className="quantity-field"
//                 readOnly
//               />
//               <button
//                 type="button"
//                 // value="+"
//                 className="button-plus"
//                 onClick={() => incrementValue(ticket.id + "-qty", ticket)}
//               ><span>+</span></button>
//             </div>
//           )}
//         </div>
//       );
//     }
//   };

//   const closeModal = () => {
//     setModalIsOpen(false);
//     setLoginOrCreate(null);
//   };

//   return (
//     <div className={"product-details"}>
//       <h1 className="product-title">{event.name}</h1>

//       <div className="product-content">
//         <p
//           dangerouslySetInnerHTML={{
//             __html: event.detail,
//           }}
//         ></p>
//       </div>

//       <div className="row" style={{ marginBottom: "40px" }}>
//         <div className="col-sm-6 col-lg-6">
//           <div className="icon-box icon-box-side">
//             <span className="icon-box-icon text-dark">
//               <i className="icon-app-store"></i>
//             </span>
//             <div className="icon-box-content">
//               <h3 className="icon-box-title">
//                 <a href="https://apps.apple.com/us/app/groovoo-social-networking/id1529056214">
//                   Download iOS
//                 </a>
//               </h3>
//               <p>Start the warm up</p>
//             </div>
//           </div>
//         </div>
//         <div className="col-sm-6 col-lg-6">
//           <div className="icon-box icon-box-side">
//             <span className="icon-box-icon text-dark">
//               <i className="icon-google-play"></i>
//             </span>
//             <div className="icon-box-content">
//               <h3 className="icon-box-title">
//                 <a href="https://play.google.com/store/apps/details?id=com.groovoo&amp;hl=pt_BR&amp;gl=US">
//                   Download Android
//                 </a>
//               </h3>
//               <p>Start the warm up</p>
//             </div>
//           </div>
//         </div>
//       </div>
//       {event.is_ticketable !== 0 &&
//         event.tickets &&
//         event.tickets.length > 0 && (
//           <>
//             <div className="details-filter-row details-row-size">
//               <div className="col-4">
//                 <label>Ticket</label>
//               </div>
//               <div className="col-4">
//                 <label>Price</label>
//               </div>
//               <div className="col-4">
//                 <label>Qty</label>
//               </div>
//             </div>

//             {event.tickets
//               .filter((t) => t.status !== 0)
//               .map((ticket, index) => (
//                 <div
//                   className="details-filter-row details-row-size"
//                   key={index}
//                 >
//                   <div className="col-4">
//                     <label
//                       style={{
//                         fontWeight: "normal",
//                         fontSize: "1.6rem",
//                         width: "100%",
//                       }}
//                     >
//                       {ticket.description}
//                     </label>
//                     {ticket.text_detail && (
//                       <button
//                         onClick={() => setShowTicketDetail(ticket)}
//                         className="btn-modalDetail"
//                       >
//                         Detail
//                       </button>
//                     )}
//                   </div>
//                   <div className="col-4">
//                     {ticket.is_paid ? (
//                       <div style={{ color: primary_color, fontSize: "1.8rem" }}>
//                         ${Number(ticket.price)}
//                       </div>
//                     ) : (
//                       <label style={{ color: "#5eaf5e", fontSize: "1.8rem" }}>
//                         FREE
//                       </label>
//                     )}
//                     {ticket.accept_installments > 0 && (
//                       <span class="badge badge-secondary">installments</span>
//                     )}
//                   </div>
//                   <div className="col-4">{quantityIfIsAvailable(ticket)}</div>
//                 </div>
//               ))}
//             {error && <AlertDiv error message={error} title="Purchase error" />}

//             <div className="product-details-action">
//               <button
//                 className="btn-product btn-cart"
//                 onClick={() => getOrder()}
//               >
//                 <span>Place Order</span>
//               </button>

//               <label style={{ marginTop: "10px" }}>
//                 {" "}
//                 Placing an order you agree with our
//                 <a
//                   href={process.env.PUBLIC_URL + "/terms.html"}
//                   target="_blank"
//                   rel="noreferrer"
//                 >
//                   {" "}
//                   Terms of Use
//                 </a>{" "}
//                 and
//                 <a
//                   href={process.env.PUBLIC_URL + "/privacy.html"}
//                   target="_blank"
//                   rel="noreferrer"
//                 >
//                   {" "}
//                   Privacy Policy
//                 </a>{" "}
//               </label>
//               {
//                 order && loggedIn ? (
//                   <div>
//                     <Redirect
//                       to={{
//                         pathname:
//                           Number(order.total_price) === 0
//                             ? `/shop/free-checkout`
//                             : `/shop/checkout`,
//                         state: {
//                           event: event,
//                           order: order,
//                         },
//                       }}
//                     />
//                   </div>
//                 ) : (
//                   order &&
//                   !loggedIn && (
//                     <div>
//                       <ModalLogin
//                         isOpen={modalIsOpen}
//                         // onAfterOpen={afterOpenModal}
//                         onRequestClose={closeModal}
//                         style={customStyles}
//                         contentLabel="Modal"
//                       >
//                         {!loginOrCreate ? (
//                           <div className="modalLogin">
//                             <span className="title">
//                               To continue, sign in or create an account
//                             </span>
//                             <button
//                               className="toLogin"
//                               onClick={() => {
//                                 setLoginOrCreate(1);
//                               }}
//                             >
//                               Login
//                             </button>
//                             <button
//                               className="toCreateAccount"
//                               onClick={() => {
//                                 setLoginOrCreate(2);
//                               }}
//                             >
//                               Create Account
//                             </button>
//                           </div>
//                         ) : (
//                           <LoginPage
//                             loginOrCreate={loginOrCreate}
//                             event={event}
//                             order={order}
//                           ></LoginPage>
//                         )}
//                       </ModalLogin>
//                     </div>
//                   )
//                 )
//                 // <div>
//                 //     <div>{orderDetail(order, event)}</div>
//                 //     {<div><Redirect to={{
//                 //         pathname: (Number(order.total_price) === 0) ? `/shop/free-checkout` : `/shop/checkout`,
//                 //         state:
//                 //         {
//                 //             event: event,
//                 //             order: order
//                 //         }
//                 //     }} />

//                 //     </div>}
//                 // </div>
//               }
//             </div>
//           </>
//         )}

//       {event.is_ticketable == 0 && event.external_shop_url && (
//         <div className="product-details-action">
//           {isIEBrowser() || isEdgeBrowser() ? (
//             <button
//               className="btn-product btn-cart"
//               style={{ minHeight: "4rem" }}
//               onClick={() => window.open(event.external_shop_url, "_blank")}
//             >
//               <span>BUY TICKETS</span>
//             </button>
//           ) : (
//             <button
//               className="btn-product btn-cart"
//               onClick={() => window.open(event.external_shop_url, "_blank")}
//             >
//               <span>BUY TICKETS</span>
//             </button>
//           )}
//         </div>
//       )}

//       {event.images.length > 2 && (
//         <div style={{ margin: "20px 0px" }}>
//           <div
//             style={{
//               display: "flex",
//               justifyContent: "center",
//               alignItems: "center",
//               paddingTop: "5px",
//             }}
//           >
//             <p style={{ fontSize: "18px", fontWeight: "500" }}>EVENT MAP</p>
//           </div>
//           <div
//             style={{
//               display: "flex",
//               justifyContent: "center",
//               alignItems: "center",
//               padding: "5px 0px 30px 0px",
//             }}
//           >
//             <img
//               src={event.images[2].url_image}
//               alt="mapa de assentos"
//               width={
//                 event.images[2].url_image.includes("feed") ? "100%" : "70%"
//               }
//               style={{ border: "3px solid #c4c4c4" }}
//             />
//           </div>
//         </div>
//       )}
//       <div className="product-details-footer">
//         <div className="product-cat">
//           <span>Category: </span>
//           <Link to="#">{event.category.description}</Link>
//         </div>
//       </div>
//       {showTicketDetail && (
//         <Modal
//           textDetail={showTicketDetail.text_detail}
//           textDetailDescription={showTicketDetail.description}
//           visible={showTicketDetail}
//           onClose={() => setShowTicketDetail(false)}
//         />
//       )}
//       {props.children}
//       {/* {teste && <div>
//         <Redirect
//             to={{
//               pathname: `${process.env.PUBLIC_URL}/login/activate-account`,
//               state: {
//                 event: event,
//                 order: order,
//                 userToActivate: 3,
//               },
//             }}
//           />
//       </div>} */}
//     </div>
//   );
// }

// export default withRouter(ProductDetailOne);
